export const legalResources = {
  en: {
    termsAndConditionsTitle: "Terms and Conditions",
    disclaimerTitle: "Disclaimer",
    privacyPolicyTitle: "Privacy Policy",
  },
  es: {
    termsAndConditionsTitle: "Terminos y Condiciones",
    disclaimerTitle: "Disclaimer",
    privacyPolicyTitle: "Aviso de Privacidad",
  },
};

export default interface IResources {
  termsAndConditionsTitle: string;
  disclaimerTitle: string;
  privacyPolicyTitle: string;
}
